import React from 'react'
import PropTypes from "prop-types"
import Component, {_isFormField, onChange} from "./Component";

class Checkbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: this.getValue()
    }

    this.input = React.createRef();
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (_isFormField(this.props) && (this.threeStateMode || this.getValue() !== null)) {
      this.props.formField.setValue((this.threeStateMode ? this.getValue() : (this.getValue() ?? false)), undefined, false);
    }
    this.input.current.addEventListener("change", this.onChange, false);
  }

  componentWillUnmount() {
    this.input.current.removeEventListener("change", this.onChange, false);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.valueDidUpdate(prevProps)) {
      const value = this.getValue();
      this.input.current.checked = !!value;
      this.setState({checked: value});
    }
  }

  render() {
    return (
      <label className={"field checkbox loadable" + this._className()}>
        <input
          ref={this.input}
          id={this.props.id}
          name={this.props.id}
          defaultChecked={this.state.checked}
          disabled={this.props.disabled}
          type="checkbox"
          onChange={onChange}
          className={(this.props.isInvalid || this.isInvalid() ? "is-invalid checkbox" : "checkbox") + (this.props.threeStateMode && this.state.checked === null ? " is-empty" : "")}/>
        <span className={'disable-select' + (this.props.fullyVisible ? ' fully-visible' : ' ')}>{this.props.label}</span>
        <div className="error-icon fz fz-exclamation-triangle solid">
          <div className="has-tooltip danger" data-tooltip={this.errorMessage()}/>
        </div>
      </label>
    )
  }

  onChange(event) {
    const value = this.getEventValue(event);

    if (this.props.threeStateMode && value === true && this.state.checked === false) {
      event.target.checked = false;
      onChange(this.props, null);
      this.setState({checked: null});

      event.preventDefault();
      event.stopPropagation();
      return false;
    }

    this.setState({
      checked: value
    });
    super.onChange(event);
    setTimeout(super.onBlur.bind(this), 1);
  }

  getValue() {
    const value = super.getValue();
    return value === "" ? null : value;
  }

  getValueProps() {
    return "checked";
  }

  getEventValue(event) {
    return event.target.checked;
  }

  _className() {
    return (this.props.className ? " " + this.props.className : "")
      + (this.props.type ? " is-" + this.props.type : "")
      + (this.props.isOutlined ? " is-outlined" : "")
      + (this.props.color ? " is-" + this.props.color : "");
  }
}

Checkbox.propTypes = {
  id: PropTypes.string,
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(["circle", "square", "form", "form-check"]),
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger", "auto"]),
  isOutlined: PropTypes.bool,
  threeStateMode: PropTypes.bool,
  label: PropTypes.string,
  isInvalid: PropTypes.bool,
  invalidMessage: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  formField: PropTypes.object,
  fullyVisible: PropTypes.bool,
};


export default Checkbox
